export const ORDER_STATUSES = ['pendiente', 'preparando', 'listo', 'entregado', 'cancelado'] as const;

export type OrderStatus = typeof ORDER_STATUSES[number];

export const STATUS_LABELS: Record<OrderStatus, string> = {
  pendiente: 'Pendiente',
  preparando: 'Preparando',
  listo: 'Listo',
  entregado: 'Entregado',
  cancelado: 'Cancelado'
};

export const STATUS_COLORS: Record<OrderStatus, string> = {
  pendiente: 'bg-red-100 text-red-600 dark:bg-red-500/10 dark:text-red-400',
  preparando: 'bg-orange-100 text-orange-600 dark:bg-orange-500/10 dark:text-orange-400',
  listo: 'bg-blue-100 text-blue-600 dark:bg-blue-500/10 dark:text-blue-400',
  entregado: 'bg-green-100 text-green-600 dark:bg-green-500/10 dark:text-green-400',
  cancelado: 'bg-slate-200 text-slate-500 dark:bg-slate-800 dark:text-slate-500'
};
